/* eslint-disable no-console */
import $ from "jquery";

const step = () => {
  const init = () => {
    handleButtonNext();
    handleButtonPrev();
    fillShippingName();
  };

  const elp = {
    buttonNext: "#js-next-step",
    form: 'form[name="checkout"]',
    checkboxWrapper: ".woocommerce-terms-and-conditions-wrapper",
  };

  // show button next only for logged in users and hide terms and conditions at first for guest
  if ($(elp.form).hasClass("logged_in") || $(elp.buttonNext).length === 0) {
    $(elp.checkboxWrapper).show();
    $(elp.buttonNext).hide();
  } else {
    $(elp.checkboxWrapper).hide();
  }

  const fillShippingName = () => {
    const el = {
      firstName: "#billing_first_name",
      lastName: "#billing_last_name",
      email: "#billing_email",
      shippingFirstName: "#shipping_first_name",
      shippingLastName: "#shipping_last_name",
      // confirmEmail: "#js-confirmation-email",
    };

    if ($(el.firstName).length === 0) return;

    $(el.shippingFirstName).val($(el.firstName).val());
    $(el.shippingLastName).val($(el.lastName).val());
    // $(el.confirmEmail).text($(el.email).val());

    $(document).on("input", el.firstName, function () {
      $(el.shippingFirstName).val($(this).val());
    });

    $(document).on("input", el.lastName, function () {
      $(el.shippingLastName).val($(this).val());
    });

    // $(document).on("input", el.email, function () {
    //   $(el.confirmEmail).text($(this).val());
    // });
  };

  const handleButtonNext = () => {
    const el = {
      anchorTop: "#anchor_top",
      buttonNext: elp.buttonNext,
      navs: ".checkout.woocommerce-checkout .navs",
      navStep2: "#nav-betaling",
      tabs: ".checkout.woocommerce-checkout .tabs",
      checkoutButton: "#place_order",
      checkboxWrapper: elp.checkboxWrapper,
      checkbox: "#terms",
    };

    if ($(el.buttonNext).length === 0) return;

    const validation = () => {
      const requiredFields = [
        "billing_first_name",
        "billing_last_name",
        "billing_address_1",
        "billing_postcode",
        "billing_city",
        "billing_phone",
        "billing_email",
        "billing_house_number",
      ];

      const isShipping = $(".checkout-shipping .shipping_address").is(
        ":visible"
      );

      if (isShipping) {
        requiredFields.push(
          ...[
            "shipping_first_name",
            "shipping_last_name",
            "shipping_address_1",
            "shipping_postcode",
            "shipping_city",
            "shipping_house_number",
          ]
        );
      }

      let count = [];
      for (let i in requiredFields) {
        const val = $(`#${requiredFields[i]}`).val();

        if (val === "") {
          count.push(requiredFields[i]);
          $(`#${requiredFields[i]}`).addClass("error");
        } else {
          $(`#${requiredFields[i]}`).removeClass("error");
        }
      }

      const hasShippingMyParcel = $(".myparcel-delivery-options__table").is(
        ":visible"
      );

      let isTermChecked = $("#terms").is(":checked");
      if ($(el.tabs).find('div[data-tab="verzending"]').is(":visible")) {
        isTermChecked = true;
      }

      if (!hasShippingMyParcel || !isTermChecked) count = [0];

      // // Phone validation
      // const phoneInput = $("#billing_phone").val();

      // const phonePattern = /^(\+?\d+)$/;
      // if (!phonePattern.test(phoneInput)) {
      //   $("#billing_phone").addClass("error");
      //   console.error("phone validation failed");
      //   count = [0];
      // } else {
      //   $("#billing_phone").removeClass("error");
      // }

      // Phone validation
      const phoneInput = $("#billing_phone").val();
      const phonePattern = /^(\+?\d+)$/;
      const errorPhone = $("#error_phone");

      if (!phonePattern.test(phoneInput)) {
        errorPhone.removeClass("hide").addClass("show");
        $("#billing_phone").addClass("error").after(errorPhone);

        setTimeout(function () {
          errorPhone.removeClass("show").addClass("hide");
        }, 2000);

        console.error("Phone validation failed");
        count = [0];
      } else {
        $("#billing_phone").removeClass("error");
        errorPhone.removeClass("show").addClass("hide");
      }

      // Email validation
      const emailInput = $("#billing_email").val();
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const errorEmail = $("#error_mail");

      if (!emailPattern.test(emailInput)) {
        errorEmail.removeClass("hide").addClass("show");
        $("#billing_email").addClass("error").after(errorEmail);

        setTimeout(function () {
          errorEmail.removeClass("show").addClass("hide");
        }, 2000);

        console.error("email validation failed");
        count = [0];
      } else {
        $("#billing_email").removeClass("error");
        errorEmail.removeClass("show").addClass("hide");
      }

      if (count.length > 0) {
        $(el.buttonNext)
          .parent()
          .append(`<p>${$(el.buttonNext).data("errormessage")}</p>`);

        setTimeout(() => {
          $(el.buttonNext).parent().find(">p").remove();
        }, 2500);
      }

      return count.length === 0;
    };

    const actionNext = (thisEL) => {
      const dataStepFor = thisEL.data("tab_for");
      // make nav active
      $(`${el.navs} #nav-${dataStepFor}`).addClass("active");
      $(`${el.tabs} >div`).slideUp(300);
      $(`${el.tabs} .js-tab-${dataStepFor}`).slideDown(300);
      $(el.checkoutButton).show(300);

      $("#order_review .coupon-wrapper").hide();

      $(el.anchorTop)[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });

      $(el.buttonNext).hide(300);
      $(el.checkboxWrapper).show();
    };

    const fillDetailInfo = () => {
      const el = {
        title: ".js-address-preview .js-name[data-for]",
        phoneNumber: ".js-address-preview .js-phone[data-for]",
        fullAddress: ".js-address-preview .js-fulladdress[data-for]",
      };

      if ($(el.title).length === 0) return;

      // title
      $(el.title).html(function () {
        const dataTarget = $(this).data("for");
        const dataTargets = dataTarget.split(",");
        let valTemp = [];
        for (let i in dataTargets) {
          valTemp.push($(`#${dataTargets[i]}`).val());
        }

        return valTemp.join(" ");
      });

      $(el.phoneNumber).html(function () {
        const dataTarget = $(this).data("for");
        return $(`#${dataTarget}`).val();
      });

      $(el.fullAddress).html(function () {
        const dataTarget = $(this).data("for");
        const dataTargets = dataTarget.split(",");
        let valTemp = [];
        for (let i in dataTargets) {
          // eslint-disable-next-line no-console
          valTemp.push($(`#${dataTargets[i]}`).val());
        }

        return `${
          valTemp[0]
        }, ${valTemp[1]}, <br> ${valTemp[2]} - ${$(`option[value="${valTemp[3]}"]`).html() ?? $("#billing_country_field").find("span > strong").text()}`;
      });
    };

    $(document).on("click", el.buttonNext, function (e) {
      e.preventDefault();
      const isValid = validation();

      if (!isValid) return;
      actionNext($(this));
      fillDetailInfo($(this));
    });

    $(document).on("click", el.navStep2, function (e) {
      e.preventDefault();
      const isValid = validation();

      if (!isValid) return;
      actionNext($(this));
    });
  };

  const handleButtonPrev = () => {
    const el = {
      anchorTop: "#anchor_top",
      navStep1: "#nav-verzending",
      navs: ".checkout.woocommerce-checkout .navs",
      tabs: ".checkout.woocommerce-checkout .tabs",
      checkoutButton: "#place_order",
      buttonBack: ".js-checkout-back",
      buttonNext: "#js-next-step",
      checkboxWrapper: ".woocommerce-terms-and-conditions-wrapper",
    };

    if ($(el.navStep1).length === 0) return;

    const actionPrev = (thisEL) => {
      const dataStepFor = thisEL.data("tab_for");
      // make nav active
      $(`${el.navs} >li`).removeClass("active");
      $(`${el.navs} #nav-${dataStepFor}`).addClass("active");

      $(`${el.tabs} >div`).slideUp(300);
      $(`${el.tabs} .js-tab-${dataStepFor}`).slideDown(300);
      $(el.checkoutButton).hide(300);
      $(el.buttonNext).show(300);
      $(el.checkboxWrapper).hide();
      $("#order_review .coupon-wrapper").show();

      $(el.anchorTop)[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    };

    $(document).on("click", el.navStep1, function (e) {
      e.preventDefault();
      actionPrev($(this));
    });

    $(document).on("click", el.buttonBack, function (e) {
      e.preventDefault();
      actionPrev($(this));
    });
  };

  init();
};

try {
  step();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
